// import React, { useState } from "react";
// import axios from 'axios';
// import Loader from '../utils/loader';

// const ImageCounts = () => {
//     const [type, setType] = useState("loan"); // loan | branch
//     const [expandedRow, setExpandedRow] = useState(null);
//     const [startDate, setStartDate] = useState()
//     const [endDate, setEndDate] = useState()
//     const [loanNumber, setLoanNumber] = useState()
//     const [partnerName, setPartnerName] = useState()
//     const [location, setLocation] = useState()
//     const [qdId, setQdId] = useState()
//     const [loading, setLoading] = useState(false);

//     const toggleRow = (index) => {
//         setExpandedRow(expandedRow === index ? null : index);
//     };

//     const findCounts = async () => {
//         setLoading(true)


//         let data1 = {
//             type: type,
//             startDate: startDate,
//             endDate: endDate,
//             partner: partnerName,
//             location: location,
//             qdId: qdId,
//             loanNumber: loanNumber
//         }
//         console.log(data1, "data aa gya hai")
//         try {
//             const response = await axios.post('http://localhost:3009/Avanti/getImageCounts', data1);

//             if (response.status === 200) {
//                 // toast.success('Data saved successfully');
//                 setLoading(false)
//                 formatData(response.data,type)
//             } else {
//                 // toast.error('Error saving data');
//                 setLoading(false)
//             }
//         } catch (error) {
//             console.error('Error saving data:', error);
//             // toast.error('Error saving data');
//             setLoading(false)
//         }
//     };
//     const formatData = (data, type) => {
//   const grouped = {};

//   data.forEach((item) => {
//     const key = type === "loan"
//       ? `${item.date}_${item.loanNumber}`
//       : `${item.date}_${item.partnerName}_${item.location}`;

//     if (!grouped[key]) {
//       grouped[key] = {
//         date: item.date,
//         loanNumber: item.loanNumber,
//         partnerName: item.partnerName,
//         location: item.location,
//         reviewerName: item.reviewerName,
//         totalCount: 0,
//         breakdown: {}
//       };
//     }

//     grouped[key].totalCount += 1;

//     const subKey = type === "loan" ? item.type : item.commentType;

//     grouped[key].breakdown[subKey] =
//       (grouped[key].breakdown[subKey] || 0) + 1;
//   });

//   return Object.values(grouped);
// };
//     return (
//         <>
//             {loading && <Loader />}
//             {/* 🔹 FILTER SECTION */}
//             <div style={{ backgroundColor: "#8080801f" }}>

//                 {/* 🔹 ROW 1 */}
//                 <div className="row mx-2">

//                     {/* TYPE */}
//                     <div className="col-md-2 mb-3 pt-2">
//                         <label className="mb-2 d-block">Type</label>
//                         <select
//                             className="form-control"
//                             value={type}
//                             onChange={(e) => setType(e.target.value)}
//                         >
//                             <option value="loan">Loan Number Wise</option>
//                             <option value="branch">Branch Wise</option>
//                         </select>
//                     </div>

//                     {/* LOAN NUMBER */}
//                     {type === "loan" && (
//                         <div className="col-md-3 mb-3 pt-2">
//                             <label className="mb-2 d-block">Enter Loan Number</label>
//                             <input
//                                 className="form-control"
//                                 placeholder="Enter Loan Number"
//                                 onChange={(e) => setLoanNumber(e.target.value)}
//                             />
//                         </div>
//                     )}

//                     {/* QD ID */}
//                     <div className="col-md-3 mb-3 pt-2">
//                         <label className="mb-2 d-block">QD ID</label>
//                         <input
//                             className="form-control"
//                             placeholder="Enter QD ID"
//                             onChange={(e) => setQdId(e.target.value)}
//                         />
//                     </div>

//                     {/* DATE RANGE */}
//                     <div className="col-md-4 mb-3 pt-2">
//                         <label className="mb-2 d-block">Date Range</label>
//                         <div className="input-group">
//                             <input
//                                 type="date"
//                                 className="form-control"
//                                 onChange={(e) => setStartDate(e.target.value)}
//                             />
//                             <span className="input-group-text">to</span>
//                             <input
//                                 type="date"
//                                 className="form-control"
//                                 onChange={(e) => setEndDate(e.target.value)}
//                             />
//                         </div>
//                     </div>



//                 </div>

//                 {/* 🔹 ROW 2 */}
//                 <div className="row mx-2 align-items-end">
//                     {/* PARTNER */}
//                     <div className="col-md-3 mb-3">
//                         <label className="mb-2 d-block">Partner Name</label>
//                         <input
//                             className="form-control"
//                             placeholder="Search Partner Name"
//                             onChange={(e) => setPartnerName(e.target.value)}
//                         />
//                     </div>
//                     {/* LOCATION */}
//                     <div className="col-md-3 mb-3">
//                         <label className="mb-2 d-block">Location Name</label>
//                         <input
//                             className="form-control"
//                             placeholder="Search Location"
//                             onChange={(e) => setLocation(e.target.value)}
//                         />
//                     </div>

                
//                     {/* BUTTONS */}
//                     <div className="col-md-6 mb-3 text-right">
//                         <button className="py-2 mainbtn mr-2" onClick={findCounts}>
//                             Find
//                         </button>
//                         <button className="py-2 mainbtn">
//                             Clear Filters
//                         </button>
//                     </div>

//                 </div>

//             </div>

//             {/* 🔹 TABLE */}
//             <div className="table-responsive mt-3">
//                 <table className="table table-bordered">
//                     <thead style={{ background: "#f1f1f1" }}>
//                         <tr>
//                             <th>Date</th>
//                             {type === "loan" && <th>Loan Number</th>}
//                             <th>Partner Name</th>
//                             <th>Location</th>
//                             <th>Reviewer Name</th>
//                             <th>Count</th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {[1, 2, 3].map((row, index) => (
//                             <React.Fragment key={index}>
//                                 <tr>
//                                     <td>04/24/2024</td>

//                                     {type === "loan" && <td>LN12345678</td>}

//                                     <td>Partner A</td>
//                                     <td>Mumbai</td>
//                                     <td>Suresh Yadav</td>

//                                     <td
//                                         style={{ cursor: "pointer", color: "blue" }}
//                                         onClick={() => toggleRow(index)}
//                                     >
//                                         5 ▼
//                                     </td>
//                                 </tr>

//                                 {/* 🔹 EXPANDED ROW */}
//                                 {expandedRow === index && (
//                                     <tr>
//                                         <td colSpan={type === "loan" ? 6 : 5}>
//                                             <div className="row">

//                                                 {/* ✅ LOAN TYPE → SINGLE TABLE */}
//                                                 {type === "loan" && (
//                                                     <div className="col-md-12">
//                                                         <table className="table table-sm">
//                                                             <thead>
//                                                                 <tr>
//                                                                     <th>Type</th>
//                                                                     <th>Count</th>
//                                                                 </tr>
//                                                             </thead>
//                                                             <tbody>
//                                                                 <tr>
//                                                                     <td>LUC</td>
//                                                                     <td>2</td>
//                                                                 </tr>
//                                                                 <tr>
//                                                                     <td>Other</td>
//                                                                     <td>3</td>
//                                                                 </tr>
//                                                             </tbody>
//                                                         </table>
//                                                     </div>
//                                                 )}

//                                                 {/* ✅ BRANCH TYPE → COMMENT TABLE */}
//                                                 {type === "branch" && (
//                                                     <div className="col-md-12">
//                                                         <table className="table table-sm">
//                                                             <thead>
//                                                                 <tr>
//                                                                     <th>Comment Type</th>
//                                                                     <th>Count</th>
//                                                                 </tr>
//                                                             </thead>
//                                                             <tbody>
//                                                                 <tr>
//                                                                     <td>Feedback</td>
//                                                                     <td>3</td>
//                                                                 </tr>
//                                                                 <tr>
//                                                                     <td>Review</td>
//                                                                     <td>2</td>
//                                                                 </tr>
//                                                             </tbody>
//                                                         </table>
//                                                     </div>
//                                                 )}

//                                             </div>
//                                         </td>
//                                     </tr>
//                                 )}
//                             </React.Fragment>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </>
//     );
// };

// export default ImageCounts;


import React, { useState } from "react";
import axios from "axios";
import Loader from "../utils/loader";

const ImageCounts = () => {
  const [type, setType] = useState("loan"); // loan | branch
  const [expandedRow, setExpandedRow] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loanNumber, setLoanNumber] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [location, setLocation] = useState("");
  const [qdId, setQdId] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  // 🔹 API CALL
  const findCounts = async () => {
    setLoading(true);

    const payload = {
      type,
      startDate,
      endDate,
      partner: partnerName,
      location,
      qdId,
      loanNumber,
    };

    try {
      const response = await axios.post(
        "http://localhost:3009/Avanti/getImageCounts",
        payload
      );

      if (response.status === 200) {
        console.log(response.data.data,"response.data")
        const formatted = formatData(response.data.data, type);
        setTableData(formatted);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
function extractComment(url) {
  let cleanUrl = url.split('?')[0];
  let fileName = decodeURIComponent(cleanUrl.split('/').pop());
  fileName = fileName.replace(/\.[^/.]+$/, '');

  let parts = fileName.split('-');

  if (parts.length === 2) {
    // format: comment-index
    return parts[0];
  }

  if (parts.length >= 4) {
    // format: partner-location-comment-index
    return parts.slice(2, -1).join('-');
  }

  return "";
}
  // 🔹 DATA FORMATTER
  const formatData = (data, type) => {
    const grouped = {};

    data.forEach((item) => {
      const date = item.date.split('T')[0]
      const key =
        type === "loan"
          ? `${date}_${item.Id}`
          : `${date}_${item.partnerName}_${item.location}`;

      if (!grouped[key]) {
        grouped[key] = {
          date: date,
          loanNumber: item.Id,
          partnerName: item.partnerName,
          location: item.location,
          reviewerName: item.reviewerName,
          totalCount: 0,
          breakdown: {},
        };
      }
      console.log(grouped,key,"key")
      grouped[key].totalCount += 1;

      const subKey =
        type === "loan" ? item.artifactType : extractComment(item.Image);

      grouped[key].breakdown[subKey] =
        (grouped[key].breakdown[subKey] || 0) + 1;
    });

    return Object.values(grouped);
  };

  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    setLoanNumber("");
    setPartnerName("");
    setLocation("");
    setQdId("");
    setTableData([]);
  };

  return (
    <>
      {loading && <Loader />}

      {/* 🔹 FILTER SECTION */}
      <div style={{ backgroundColor: "#8080801f" }}>
        
        {/* ROW 1 */}
        <div className="row mx-2">

          <div className="col-md-2 mb-3 pt-2">
            <label>Type</label>
            <select
              className="form-control"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="loan">Loan Number Wise</option>
              <option value="branch">Branch Wise</option>
            </select>
          </div>

          {type === "loan" && (
            <div className="col-md-3 mb-3 pt-2">
              <label>Loan Number</label>
              <input
                className="form-control"
                placeholder="Enter Loan Number"
                value={loanNumber}
                onChange={(e) => setLoanNumber(e.target.value)}
              />
            </div>
          )}

          <div className="col-md-3 mb-3 pt-2">
            <label>QD ID</label>
            <input
              className="form-control"
              placeholder="Enter QD ID"
              value={qdId}
              onChange={(e) => setQdId(e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3 pt-2">
            <label>Date Range</label>
            <div className="input-group">
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <span className="input-group-text">to</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* ROW 2 */}
        <div className="row mx-2 align-items-end">

          <div className="col-md-3 mb-3">
            <label>Partner Name</label>
            <input
              className="form-control"
              value={partnerName}
              onChange={(e) => setPartnerName(e.target.value)}
            />
          </div>

          <div className="col-md-3 mb-3">
            <label>Location</label>
            <input
              className="form-control"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </div>

          <div className="col-md-6 mb-3 text-right">
            <button className="py-2 mainbtn mr-2" onClick={findCounts}>
              Find
            </button>
            <button className="py-2 mainbtn" onClick={clearFilters}>
              Clear Filters
            </button>
          </div>

        </div>
      </div>

      {/* 🔹 TABLE */}
      <div className="table-responsive mt-3">
        <table className="table table-bordered">
          <thead style={{ background: "#f1f1f1" }}>
            <tr>
              <th>Date</th>
              {type === "loan" && <th>Loan Number</th>}
              <th>Partner Name</th>
              <th>Location</th>
              <th>Reviewer Name</th>
              <th>Count</th>
            </tr>
          </thead>

          <tbody>
            {tableData.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}

            {tableData.map((row, index) => (
              <React.Fragment key={index}>
                {console.log(row,"kjkjk")}
                <tr>
                  <td>{row.date}</td>

                  {type === "loan" && <td>{row.loanNumber}</td>}

                  <td>{row.partnerName}</td>
                  <td>{row.location}</td>
                  <td>{row.reviewerName}</td>

                  <td
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => toggleRow(index)}
                  >
                    {row.totalCount} ▼
                  </td>
                </tr>

                {expandedRow === index && (
                  <tr>
                    <td colSpan={type === "loan" ? 6 : 5}>
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>
                              {type === "loan"
                                ? "Type"
                                : "Comment Type"}
                            </th>
                            <th>Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(row.breakdown).map(
                            ([key, value], i) => (
                              <tr key={i}>
                                <td>{key}</td>
                                <td>{value}</td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ImageCounts;